<ng-container
  *ngIf="{
    product: product$ | async,
    article: article$ | async,
    articleRefs: articleRefs$ | async,
    articleListCurrentPage: articleListCurrentPage$ | async,
    articleListTotalPageCount: articleListTotalPageCount$ | async,
    articleListQueryParams: articleListQueryParams$ | async,
    assortmentTableState: assortmentTableState$ | async,
    activeTab: activeTab$ | async,
    materialComposition: materialComposition$ | async,
    productDocuments: productDocuments$ | async,
    washingInstructionIcons: washingInstructionIcons$ | async,
    washingInstructionGroups: washingInstructionGroups$ | async,
    productCertificationGroups: productCertificationGroups$ | async,
    printingTechnologiesGroups: printingTechnologiesGroups$ | async,
    technicalAttributesTableState: technicalAttributesTableState$ | async,
  } as data"
>
  <div class="position-relative">
    <ul
      ngbNav
      pyNavSideScroll
      #nav="ngbNav"
      [activeId]="data.activeTab"
      (activeIdChange)="selectTab.emit($event)"
      class="nav-tabs nav active-tab-border side-scroll hide-on-print border-bottom"
    >
      <li
        [ngbNavItem]="PdpTabTypes.ArticleList"
        [class.disabled]="
          data.product?.articles?.length === 1 || data.product?.articlePickerAttributes?.length > 0 || data.product?.promotional
        "
      >
        <a ngbNavLink>{{ 'product.articles_tab' | cxTranslate }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="articleListTemplate"></ng-container>
        </ng-template>
      </li>

      <li
        [ngbNavItem]="PdpTabTypes.ProductInformation"
        [class.disabled]="
          !data.product?.longDescription &&
          !data.product?.uniqueSellingPoints?.points?.length &&
          !data.materialComposition?.length &&
          !(data.washingInstructionIcons?.length || data.washingInstructionGroups?.length)
        "
      >
        <a ngbNavLink>{{ 'product.productInformation_tab' | cxTranslate }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="productInformationTemplate"> </ng-container>
        </ng-template>
      </li>

      <li
        [ngbNavItem]="PdpTabTypes.TechnicalAttributes"
        [class.disabled]="!data.product?.extraInfo?.topics?.includes(productDetailsTopic.TECHNICAL_DATA_TABLE)"
      >
        <a ngbNavLink>{{ 'product.technicalAttributes_tab' | cxTranslate }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="technicalAttributesTemplate"> </ng-container>
        </ng-template>
      </li>
      <li
        [ngbNavItem]="PdpTabTypes.Assortment"
        [class.disabled]="!data.product?.extraInfo?.topics?.includes(productDetailsTopic.ASSORTMENT_PACKAGING_TABLE)"
      >
        <a ngbNavLink>{{ 'product.assortment_tab' | cxTranslate }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="assortmentTemplate"> </ng-container>
        </ng-template>
      </li>
      <li [ngbNavItem]="PdpTabTypes.CertificateInformation" [class.disabled]="!data.productCertificationGroups?.length">
        <a ngbNavLink>{{ 'product.certificateInformation_tab' | cxTranslate }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="certificateInformationTemplate"> </ng-container>
        </ng-template>
      </li>
      <li
        [ngbNavItem]="PdpTabTypes.TechnicalCapabilities"
        [class.disabled]="(data.product?.extraInfo?.technicalCapabilities | json) === '{}'"
      >
        <a ngbNavLink>{{ 'product.technicalCapabilities_tab' | cxTranslate }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="technicalCapabilitiesTemplate"> </ng-container>
        </ng-template>
      </li>
      <li [ngbNavItem]="PdpTabTypes.PrintingTechnologies" [class.disabled]="!data.printingTechnologiesGroups?.length">
        <a ngbNavLink>{{ 'product.printingTechnologies_tab' | cxTranslate }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="printingTechnologiesTemplate"> </ng-container>
        </ng-template>
      </li>
      <li [ngbNavItem]="PdpTabTypes.Applications" [class.disabled]="data.product?.extraInfo?.applications?.length === 0">
        <a ngbNavLink>{{ 'product.applications_tab' | cxTranslate }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="applicationsTemplate"> </ng-container>
        </ng-template>
      </li>
      <li
        [ngbNavItem]="PdpTabTypes.Documents"
        [class.disabled]="
          !data.product?.productDownloadables &&
          !data.product?.datasheet &&
          !(!!data.article?.safetyDatasheetUrl || !!data.article?.datasheet?.url) &&
          !data.productDocuments?.length
        "
      >
        <a ngbNavLink>{{ 'product.documents_tab' | cxTranslate }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="documentsTemplate"> </ng-container>
        </ng-template>
      </li>

      <li *ngFor="let tabContainer of tabContainers" [ngbNavItem]="tabContainer.uid">
        <a ngbNavLink>{{ tabContainer.tabName }}</a>

        <ng-template ngbNavContent>
          <ng-container [cxComponentWrapper]="tabContainer"></ng-container>
        </ng-template>
      </li>
    </ul>
  </div>

  <div [ngbNavOutlet]="nav" class="mt-5"></div>

  <ng-template #articleListTemplate>
    <div>
      <py-catalog-article-list
        [articleRefs]="data.articleRefs"
        [queryParams]="data.articleListQueryParams"
        [itemListType]="ltemListTypePDP"
      ></py-catalog-article-list>
      <div class="col-10 col-md-4 offset-1 offset-md-4 my-4" *ngIf="data.product?.articles?.length > articleListPageCount">
        <py-load-more
          [totalItemCount]="data.product?.articles?.length"
          [totalPageCount]="data.articleListTotalPageCount"
          [currentPageNumber]="data.articleListCurrentPage"
          [itemCount]="data.articleRefs?.length || 0"
          (dispatch)="nextPage($event)"
        ></py-load-more>
      </div>
    </div>
  </ng-template>

  <ng-template #productInformationTemplate>
    <div class="row">
      <div class="col-12 col-md-6 mb-4 mb-md-0">
        <div *ngIf="data.product?.uniqueSellingPoints?.points?.length" class="mb-4">
          <ul>
            <li *ngFor="let point of data.product?.uniqueSellingPoints?.points">
              <i nz-icon nzType="check-circle" nzTheme="fill" class="mr-1 text-primary"></i>
              {{ point.point }}
            </li>
          </ul>
        </div>
        <p *ngIf="data.product?.longDescription" class="long-description">
          <span [innerHTML]="data.product?.longDescription"></span>
        </p>
      </div>
      <div class="col-12 col-md-6">
        <div class="mb-2" *ngIf="data.materialComposition?.length">
          <div *ngFor="let group of data.materialComposition || []">
            <h4>{{ group.description }}</h4>
            <ul class="mt-1 mb-2">
              <li *ngFor="let cert of group.certificates">
                <i nz-icon nzType="check-circle" nzTheme="fill" class="mr-2 text-primary"></i>
                {{ cert.description }}
              </li>
            </ul>
          </div>
        </div>
        <div class="mb-2" *ngIf="data.washingInstructionIcons?.length || data.washingInstructionGroups?.length">
          <div *ngFor="let group of data.washingInstructionGroups || []">
            <h4>{{ group.description }}</h4>
            <ul class="mt-1 mb-2">
              <li *ngFor="let cert of group.certificates">
                <i nz-icon nzType="check-circle" nzTheme="fill" class="mr-2 text-primary"></i>
                {{ cert.description }}
              </li>
            </ul>
          </div>
          <div class="d-flex mb-2">
            <img
              *ngFor="let instructionIcon of data.washingInstructionIcons || []; let i = index"
              class="instruction-icon"
              [ngClass]="{ 'ml-2': i > 0 }"
              [pyMedia]="instructionIcon.icon"
              [alt]="instructionIcon.name"
              [ngbTooltip]="instructionIcon.name"
            />
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #certificateInformationTemplate>
    <div *ngFor="let group of data.productCertificationGroups || []">
      <h4>{{ group.description }}</h4>
      <ul class="mb-2">
        <li *ngFor="let cert of group.certificates">
          <i nz-icon nzType="check-circle" nzTheme="fill" class="mr-2 text-primary"></i>
          {{ cert.description }}
        </li>
      </ul>
    </div>
  </ng-template>

  <ng-template #applicationsTemplate>
    <ul class="mb-2">
      <li *ngFor="let application of data.product?.extraInfo?.applications || []">
        <i nz-icon nzType="check-circle" nzTheme="fill" class="mr-2 text-primary"></i>
        {{ application }}
      </li>
    </ul>
  </ng-template>

  <ng-template #technicalCapabilitiesTemplate>
    <div class="row mb-2" *ngFor="let capability of data.product?.extraInfo?.technicalCapabilities.entry | keyvalue">
      <div class="col-md-3">
        <h6>{{ capability.value.key }}</h6>
      </div>
      <div class="col-md-9">{{ capability.value.value }}</div>
    </div>
  </ng-template>

  <ng-template #printingTechnologiesTemplate>
    <div *ngFor="let group of data.printingTechnologiesGroups || []">
      <h5>{{ group.description }}</h5>
      <ul class="mb-2">
        <li *ngFor="let cert of group.certificates">
          <i nz-icon nzType="check-circle" nzTheme="fill" class="mr-2 text-primary"></i>
          {{ cert.description }}
        </li>
      </ul>
    </div>
  </ng-template>

  <ng-template #technicalAttributesTemplate>
    <ng-container
      [ngSwitch]="
        !!data.technicalAttributesTableState?.error
          ? 'error'
          : !!data.technicalAttributesTableState?.loading
            ? 'loading'
            : !data.technicalAttributesTableState?.data?.attributes?.length
              ? 'empty'
              : 'ready'
      "
    >
      <ng-container *ngSwitchCase="'error'" [ngTemplateOutlet]="errorTabTemplate"></ng-container>
      <ng-container *ngSwitchCase="'loading'" [ngTemplateOutlet]="loadingTabTemplate"></ng-container>
      <ng-container *ngSwitchCase="'empty'">
        <div class="text-center py-6">{{ 'product.noTechnicalDataAvailable_text' | cxTranslate }}</div>
      </ng-container>
      <ng-container *ngSwitchCase="'ready'">
        <py-technical-attributes-table [attributes]="data.technicalAttributesTableState?.data?.attributes">
        </py-technical-attributes-table>
        <p class="pt-2">
          {{ 'product.technicalAttributesDisclaimer_text' | cxTranslate }}
        </p>
      </ng-container>
    </ng-container>
  </ng-template>

  <ng-template #assortmentTemplate>
    <ng-container
      [ngSwitch]="
        !!data.assortmentTableState?.error
          ? 'error'
          : !!data.assortmentTableState?.loading
            ? 'loading'
            : !data.assortmentTableState?.data?.assortment?.length
              ? 'empty'
              : 'ready'
      "
    >
      <ng-container *ngSwitchCase="'error'" [ngTemplateOutlet]="errorTabTemplate"></ng-container>
      <ng-container *ngSwitchCase="'loading'" [ngTemplateOutlet]="loadingTabTemplate"></ng-container>
      <ng-container *ngSwitchCase="'empty'">
        <div class="text-center py-6">{{ 'product.noAssortmentDataAvailable_text' | cxTranslate }}</div>
      </ng-container>
      <ng-container *ngSwitchCase="'ready'">
        <ul class="pb-2">
          <li class="pr-2 d-block d-md-inline">
            <i nz-icon nzType="reamed" nzTheme="outline" class="pr-2 icon"></i>{{ 'product.reamed_heading' | cxTranslate }}
          </li>
          <li class="pr-2 d-block d-md-inline">
            <i nz-icon nzType="bulk_on_flex" nzTheme="outline" class="pr-2 icon"></i
            >{{ 'product.unreamed_heading' | cxTranslate }}
          </li>
          <li class="pr-2 d-block d-md-inline">
            <i nz-icon nzType="bulk" nzTheme="outline" class="pr-2 icon"></i>{{ 'product.bulked_heading' | cxTranslate }}
          </li>
        </ul>
        <py-assortment-table
          [assortment]="data.assortmentTableState?.data?.assortment"
          [grammages]="data.assortmentTableState?.data?.grammages"
        ></py-assortment-table>
      </ng-container>
    </ng-container>
  </ng-template>

  <ng-template #loadingTabTemplate>
    <cx-spinner class="py-6"></cx-spinner>
  </ng-template>

  <ng-template #errorTabTemplate>
    <div class="text-center py-6">
      <i nz-icon nzType="exclamation-circle-o" class="text-danger mr-2 align-text-bottom"></i>
      <span>{{ 'errors.unexpectedError_message' | cxTranslate }}</span>
    </div>
  </ng-template>

  <ng-template #documentsTemplate>
    <cx-generic-link *ngIf="!!data.article?.safetyDatasheetUrl" [url]="data.article?.safetyDatasheetUrl" target="_blank">
      <div class="d-flex align-items-center mb-2">
        <div class="download-icon-holder mr-2">
          <i nz-icon nzType="file-protect" class="download-icon"></i>
        </div>
        {{ 'article.safetyDatasheet_tooltip' | cxTranslate }}
      </div>
    </cx-generic-link>
    <cx-generic-link *ngIf="!!data.article?.datasheet?.url" [url]="data.article?.datasheet?.url" target="_blank">
      <div class="d-flex align-items-center mb-2">
        <div class="download-icon-holder mr-2">
          <i nz-icon nzType="file-pdf" class="download-icon"></i>
        </div>
        {{ 'article.datasheet_tooltip' | cxTranslate }}
      </div>
    </cx-generic-link>

    <cx-generic-link
      *ngIf="!!data.product?.datasheet?.url && !data.article?.datasheet?.url"
      [url]="data.product?.datasheet?.url"
      target="_blank"
    >
      <div class="d-flex align-items-center mb-2">
        <div class="download-icon-holder mr-2">
          <i nz-icon nzType="file-done" class="download-icon"></i>
        </div>
        {{ 'product.datasheet_tooltip' | cxTranslate }}
      </div>
    </cx-generic-link>

    <cx-generic-link
      *ngFor="let productDownloadable of data.product?.productDownloadables"
      [url]="productDownloadable.downloadUrl"
      target="_blank"
    >
      <div class="d-flex align-items-center mb-2">
        <div class="download-icon-holder mr-2">
          <i nz-icon nzType="file-pdf" class="download-icon"></i>
        </div>
        {{ productDownloadable.linkText }}
      </div>
    </cx-generic-link>

    <cx-generic-link *ngFor="let productDocument of data.productDocuments" [url]="productDocument.downloadUrl" target="_blank">
      <div class="d-flex align-items-center mb-2">
        <div class="download-icon-holder mr-2">
          <i nz-icon nzType="file-pdf" class="download-icon"></i>
        </div>
        {{ productDocument.title }}
      </div>
    </cx-generic-link>
  </ng-template>
</ng-container>
